import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface DocumentationState {
  isOpen: boolean
  currentSection: string | null
  currentArticle: string | null
  searchQuery: string
  lastViewedPath: string | null
  hasSeenDocs: boolean
  open: () => void
  close: () => void
  openArticle: (sectionId: string, articleId: string) => void
  setSearchQuery: (query: string) => void
  markAsSeen: () => void
}

export const useDocumentation = create<DocumentationState>()(
  persist(
    (set) => ({
      isOpen: false,
      currentSection: 'getting-started',
      currentArticle: 'login',
      searchQuery: '',
      lastViewedPath: null,
      hasSeenDocs: false,
      
      open: () => set({ isOpen: true }),
      
      close: () => set({ isOpen: false }),
      
      openArticle: (sectionId, articleId) => set({
        currentSection: sectionId,
        currentArticle: articleId,
        isOpen: true,
        lastViewedPath: `${sectionId}:${articleId}`
      }),
      
      setSearchQuery: (query) => set({ searchQuery: query }),
      
      markAsSeen: () => set({ hasSeenDocs: true })
    }),
    {
      name: 'documentation-storage',
      partialize: (state) => ({
        lastViewedPath: state.lastViewedPath,
        hasSeenDocs: state.hasSeenDocs,
        currentSection: state.currentSection,
        currentArticle: state.currentArticle
      })
    }
  )
)